import { render, staticRenderFns } from "./PoolGoodsList.vue?vue&type=template&id=5e9f5c70"
import script from "./PoolGoodsList.vue?vue&type=script&lang=js"
export * from "./PoolGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports